const countryOption_Israel = { country: 'Israel' };
const USAStates = [{ label: 'South Carolina', initials: 'SC' }, { label: 'Minnesota', initials: 'MN' }];
const countryOption_USA = { country: 'USA', states: USAStates };
export const countryOptions = [countryOption_Israel, countryOption_USA];
export const ViewKey_Edit = 'edit';
export const ViewKey_View = 'view';
//# sourceMappingURL=consts.js.map